// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorImage {height: 400px;object-fit: contain;}
.notFoundHeading {font-size: 80px;}`, "",{"version":3,"sources":["webpack://./src/Styles/error404.css"],"names":[],"mappings":"AAAA,aAAa,aAAa,CAAC,mBAAmB,CAAC;AAC/C,kBAAkB,eAAe,CAAC","sourcesContent":[".errorImage {height: 400px;object-fit: contain;}\n.notFoundHeading {font-size: 80px;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
